// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("webfonts/Gentona-Heavy.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("webfonts/Gentona-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("webfonts/Gentona-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("webfonts/Gentona-HeavyItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("webfonts/Gentona-HeavyItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("webfonts/Gentona-HeavyItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("webfonts/Gentona-ExtraBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("webfonts/Gentona-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("webfonts/Gentona-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("webfonts/Gentona-ExtraBoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("webfonts/Gentona-ExtraBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("webfonts/Gentona-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("webfonts/Gentona-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("webfonts/Gentona-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("webfonts/Gentona-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("webfonts/Gentona-BoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("webfonts/Gentona-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("webfonts/Gentona-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("webfonts/Gentona-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("webfonts/Gentona-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("webfonts/Gentona-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("webfonts/Gentona-SemiBoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("webfonts/Gentona-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("webfonts/Gentona-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("webfonts/Gentona-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("webfonts/Gentona-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("webfonts/Gentona-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("webfonts/Gentona-MediumItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("webfonts/Gentona-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("webfonts/Gentona-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("webfonts/Gentona-Book.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("webfonts/Gentona-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("webfonts/Gentona-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("webfonts/Gentona-BookItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("webfonts/Gentona-BookItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("webfonts/Gentona-BookItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("webfonts/Gentona-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("webfonts/Gentona-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("webfonts/Gentona-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("webfonts/Gentona-LightItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("webfonts/Gentona-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("webfonts/Gentona-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("webfonts/Gentona-ExtraLight.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("webfonts/Gentona-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("webfonts/Gentona-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("webfonts/Gentona-ExtraLightItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("webfonts/Gentona-ExtraLightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("webfonts/Gentona-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("webfonts/Gentona-Thin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("webfonts/Gentona-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("webfonts/Gentona-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("webfonts/Gentona-ThinItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("webfonts/Gentona-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("webfonts/Gentona-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * MyFonts Webfont Build ID 2792584, 2014-04-10T13:17:10-0400
 *
 * The fonts listed in this notice are subject to the End User License
 * Agreement(s) entered into by the website owner. All other parties are
 * explicitly restricted from using the Licensed Webfonts(s).
 *
 * License: http://www.myfonts.com/viewlicense?type=web&buildid=2792584
 * Licensed pageviews: 1,000,000
 *
 * © 2014 MyFonts Inc
*/

/* @import must be at top of file, otherwise CSS will not work */
/* @import url("//hello.myfonts.net/count/2a9c88"); */




/*////////////////////////////////////////////////////////////////////////////*/
/*/// GENTONA ////////////////////////////////////////////////////////////////*/
/*////////////////////////////////////////////////////////////////////////////*/

/*===================*/
/*=== Heavy (900) ===*/
/*===================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: 900;
  font-style: italic;
}





/*========================*/
/*=== Extra Bold (800) ===*/
/*========================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
  font-weight: 800;
  font-style: italic;
}





/*==================*/
/*=== Bold (700) ===*/
/*==================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
  font-weight: 700;
  font-style: italic;
}





/*======================*/
/*=== Semi-Bold (600) ===*/
/*======================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('truetype');
  font-weight: 600;
  font-style: italic;
}





/*====================*/
/*=== Medium (500) ===*/
/*====================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format('truetype');
  font-weight: 500;
  font-style: italic;
}





/*==================*/
/*=== Book (400) ===*/
/*==================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format('truetype');
  font-weight: 400;
  font-style: italic;
}





/*===================*/
/*=== Light (300) ===*/
/*===================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format('truetype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format('truetype');
  font-weight: 300;
  font-style: italic;
}





/*=========================*/
/*=== Extra Light (200) ===*/
/*=========================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format('truetype');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_61___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_62___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_63___}) format('truetype');
  font-weight: 200;
  font-style: italic;
}





/*==================*/
/*=== Thin (100) ===*/
/*==================*/
@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_66___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_67___}) format('truetype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'gentona';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) format('embedded-opentype'),
       url(${___CSS_LOADER_URL_REPLACEMENT_70___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_71___}) format('truetype');
  font-weight: 100;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/Web/gentona/gentona.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;CAYC;;AAED,gEAAgE;AAChE,qDAAqD;;;;;AAKrD,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;AACtB;EACE,sBAAsB;EACtB,4CAAsC;EACtC;;iEAEyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C;;iEAE+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,2BAA2B;AAC3B,2BAA2B;AAC3B,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,4CAA0C;EAC1C;;kEAE6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAgD;EAChD;;kEAEmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,qBAAqB;AACrB,qBAAqB;AACrB,qBAAqB;AACrB;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;kEAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA2C;EAC3C;;kEAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,yBAAyB;AACzB,0BAA0B;AAC1B,yBAAyB;AACzB;EACE,sBAAsB;EACtB,6CAAyC;EACzC;;kEAE4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA+C;EAC/C;;kEAEkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,uBAAuB;AACvB,uBAAuB;AACvB,uBAAuB;AACvB;EACE,sBAAsB;EACtB,6CAAuC;EACvC;;kEAE0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C;;kEAEgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,qBAAqB;AACrB,qBAAqB;AACrB,qBAAqB;AACrB;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;kEAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA2C;EAC3C;;kEAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;AACtB;EACE,sBAAsB;EACtB,6CAAsC;EACtC;;kEAEyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA4C;EAC5C;;kEAE+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,4BAA4B;AAC5B,4BAA4B;AAC5B,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,6CAA2C;EAC3C;;kEAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAiD;EACjD;;kEAEoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;;;;;AAMA,qBAAqB;AACrB,qBAAqB;AACrB,qBAAqB;AACrB;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;kEAEwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA2C;EAC3C;;kEAE8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/**\n * @license\n * MyFonts Webfont Build ID 2792584, 2014-04-10T13:17:10-0400\n *\n * The fonts listed in this notice are subject to the End User License\n * Agreement(s) entered into by the website owner. All other parties are\n * explicitly restricted from using the Licensed Webfonts(s).\n *\n * License: http://www.myfonts.com/viewlicense?type=web&buildid=2792584\n * Licensed pageviews: 1,000,000\n *\n * © 2014 MyFonts Inc\n*/\n\n/* @import must be at top of file, otherwise CSS will not work */\n/* @import url(\"//hello.myfonts.net/count/2a9c88\"); */\n\n\n\n\n/*////////////////////////////////////////////////////////////////////////////*/\n/*/// GENTONA ////////////////////////////////////////////////////////////////*/\n/*////////////////////////////////////////////////////////////////////////////*/\n\n/*===================*/\n/*=== Heavy (900) ===*/\n/*===================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Heavy.eot');\n  src: url('webfonts/Gentona-Heavy.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Heavy.woff') format('woff'),\n       url('webfonts/Gentona-Heavy.ttf') format('truetype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-HeavyItalic.eot');\n  src: url('webfonts/Gentona-HeavyItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-HeavyItalic.woff') format('woff'),\n       url('webfonts/Gentona-HeavyItalic.ttf') format('truetype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n\n\n\n\n/*========================*/\n/*=== Extra Bold (800) ===*/\n/*========================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-ExtraBold.eot');\n  src: url('webfonts/Gentona-ExtraBold.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-ExtraBold.woff') format('woff'),\n       url('webfonts/Gentona-ExtraBold.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-ExtraBoldItalic.eot');\n  src: url('webfonts/Gentona-ExtraBoldItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-ExtraBoldItalic.woff') format('woff'),\n       url('webfonts/Gentona-ExtraBoldItalic.ttf') format('truetype');\n  font-weight: 800;\n  font-style: italic;\n}\n\n\n\n\n\n/*==================*/\n/*=== Bold (700) ===*/\n/*==================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Bold.eot');\n  src: url('webfonts/Gentona-Bold.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Bold.woff') format('woff'),\n       url('webfonts/Gentona-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-BoldItalic.eot');\n  src: url('webfonts/Gentona-BoldItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-BoldItalic.woff') format('woff'),\n       url('webfonts/Gentona-BoldItalic.ttf') format('truetype');\n  font-weight: 700;\n  font-style: italic;\n}\n\n\n\n\n\n/*======================*/\n/*=== Semi-Bold (600) ===*/\n/*======================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-SemiBold.eot');\n  src: url('webfonts/Gentona-SemiBold.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-SemiBold.woff') format('woff'),\n       url('webfonts/Gentona-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-SemiBoldItalic.eot');\n  src: url('webfonts/Gentona-SemiBoldItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-SemiBoldItalic.woff') format('woff'),\n       url('webfonts/Gentona-SemiBoldItalic.ttf') format('truetype');\n  font-weight: 600;\n  font-style: italic;\n}\n\n\n\n\n\n/*====================*/\n/*=== Medium (500) ===*/\n/*====================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Medium.eot');\n  src: url('webfonts/Gentona-Medium.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Medium.woff') format('woff'),\n       url('webfonts/Gentona-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-MediumItalic.eot');\n  src: url('webfonts/Gentona-MediumItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-MediumItalic.woff') format('woff'),\n       url('webfonts/Gentona-MediumItalic.ttf') format('truetype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n\n\n\n\n/*==================*/\n/*=== Book (400) ===*/\n/*==================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Book.eot');\n  src: url('webfonts/Gentona-Book.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Book.woff') format('woff'),\n       url('webfonts/Gentona-Book.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-BookItalic.eot');\n  src: url('webfonts/Gentona-BookItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-BookItalic.woff') format('woff'),\n       url('webfonts/Gentona-BookItalic.ttf') format('truetype');\n  font-weight: 400;\n  font-style: italic;\n}\n\n\n\n\n\n/*===================*/\n/*=== Light (300) ===*/\n/*===================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Light.eot');\n  src: url('webfonts/Gentona-Light.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Light.woff') format('woff'),\n       url('webfonts/Gentona-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-LightItalic.eot');\n  src: url('webfonts/Gentona-LightItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-LightItalic.woff') format('woff'),\n       url('webfonts/Gentona-LightItalic.ttf') format('truetype');\n  font-weight: 300;\n  font-style: italic;\n}\n\n\n\n\n\n/*=========================*/\n/*=== Extra Light (200) ===*/\n/*=========================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-ExtraLight.eot');\n  src: url('webfonts/Gentona-ExtraLight.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-ExtraLight.woff') format('woff'),\n       url('webfonts/Gentona-ExtraLight.ttf') format('truetype');\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-ExtraLightItalic.eot');\n  src: url('webfonts/Gentona-ExtraLightItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-ExtraLightItalic.woff') format('woff'),\n       url('webfonts/Gentona-ExtraLightItalic.ttf') format('truetype');\n  font-weight: 200;\n  font-style: italic;\n}\n\n\n\n\n\n/*==================*/\n/*=== Thin (100) ===*/\n/*==================*/\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-Thin.eot');\n  src: url('webfonts/Gentona-Thin.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-Thin.woff') format('woff'),\n       url('webfonts/Gentona-Thin.ttf') format('truetype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'gentona';\n  src: url('webfonts/Gentona-ThinItalic.eot');\n  src: url('webfonts/Gentona-ThinItalic.eot?#iefix') format('embedded-opentype'),\n       url('webfonts/Gentona-ThinItalic.woff') format('woff'),\n       url('webfonts/Gentona-ThinItalic.ttf') format('truetype');\n  font-weight: 100;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
